import { forwardRef } from "react";
import { UserCircle, CheckCircle, AlertTriangle, Phone } from "lucide-react";
import { motion } from "framer-motion";

const AccountSection = forwardRef(({ step, isLoggedIn, currentUser, redirectToLogin }, ref) => (
  <div ref={ref} className="bg-[#111111] border border-white/[0.08] rounded-2xl p-4 sm:p-6">
    <div className="flex items-center gap-3 mb-5">
      <div className="w-9 h-9 bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-xl flex items-center justify-center">
        <UserCircle className="h-5 w-5 text-[#FF6B35]" />
      </div>
      <div>
        <h2 className="text-base sm:text-lg font-bold text-white">Account Information</h2>
        <p className="text-xs text-gray-500 hidden sm:block">Verify your account details</p>
      </div>
    </div>

    {isLoggedIn ? (
      <div className="space-y-3">
        <div className="flex items-center gap-2 px-3 py-2 bg-green-500/10 border border-green-500/20 rounded-xl">
          <CheckCircle className="h-4 w-4 text-green-400 flex-shrink-0" />
          <p className="text-sm font-semibold text-green-400">Account Verified — ready to proceed</p>
        </div>

        <div className="bg-white/[0.04] border border-white/[0.08] rounded-xl p-4">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-[#FF6B35] rounded-full flex items-center justify-center text-white font-bold text-base flex-shrink-0">
              {currentUser?.name?.charAt(0).toUpperCase() || "U"}
            </div>
            <div className="min-w-0">
              <p className="font-semibold text-white text-sm truncate">{currentUser?.name || "User"}</p>
              <p className="text-xs text-gray-500 truncate">{currentUser?.email || "No email provided"}</p>
            </div>
          </div>
          {currentUser?.phoneNumber && (
            <div className="flex items-center gap-2 mt-3 pt-3 border-t border-white/[0.06]">
              <Phone className="h-4 w-4 text-[#FF6B35] flex-shrink-0" />
              <span className="text-sm text-gray-400">{currentUser.phoneNumber}</span>
            </div>
          )}
        </div>
      </div>
    ) : (
      <div className="space-y-3">
        <div className="flex items-center gap-2 px-3 py-2 bg-yellow-500/10 border border-yellow-500/20 rounded-xl">
          <AlertTriangle className="h-4 w-4 text-yellow-400 flex-shrink-0" />
          <p className="text-sm font-semibold text-yellow-400">Login required to continue</p>
        </div>

        <motion.button
          whileTap={{ scale: 0.97 }}
          onClick={() => redirectToLogin("Please login to continue with checkout")}
          className="w-full px-4 py-3 bg-[#FF6B35] hover:bg-[#E85520] text-white text-sm font-bold rounded-xl transition-colors flex items-center justify-center gap-2"
        >
          <UserCircle className="h-4 w-4" />
          Login to Continue
        </motion.button>
      </div>
    )}
  </div>
));

AccountSection.displayName = "AccountSection";
export default AccountSection;
